import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getAppInstance, USE_EMULATOR } from './firebaseConfig';

// Use the explicit accessor (returns the real FirebaseApp, not a Proxy) so
// the Functions SDK can stash internal client state on the app instance
// without going through Proxy traps.
const functions = getFunctions(getAppInstance());

// Dev-only: route callable invocations to the local emulator when
// REACT_APP_USE_EMULATOR=1. Strict opt-in — see firebaseConfig.js.
if (USE_EMULATOR) {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

// NOTE: getCarouselFeed used to be declared here as a dedicated callable. It
// moved to theaWeb/callables.ts on 2026-09-01 when it was enrolled in the warm
// `theaWebAI` dispatcher — every dispatcher-routed wrapper lives there, and
// this module stays what it says it is: the Functions SDK bootstrap.
export { functions };
